import { Form, Select } from 'antd';
import React from 'react';
import { textOnly } from '../../util/util';

export default function Skiptopart({ index }) {
    const form = Form.useFormInstance();
    const part = form.getFieldValue('part');

    return (
        part.length - 1 !== index && (
            <div className="font-semibold flex items-center gap-2">
                <span>ต่อจากส่วนที่ {index + 1}</span>
                <Form.Item name={[index, 'skipToPart']} className="mb-0 w-230">
                    <Select size="large">
                        {part.map((item, index) => {
                            const _textOnly = (name) =>
                                name ? textOnly(name) : 'ส่วนไม่มีชื่อ';
                            if (index === 0)
                                return (
                                    <Select.Option key={index} value={null}>
                                        ไปยังส่วนถัดไป
                                    </Select.Option>
                                );
                            else
                                return (
                                    <Select.Option
                                        key={index}
                                        value={index + 1}
                                    >{`ไปที่ส่วน ${index + 1} (${_textOnly(
                                        item.partName
                                    )})`}</Select.Option>
                                );
                        })}
                    </Select>
                </Form.Item>
            </div>
        )
    );
}
